module.exports = __webpack_public_path__ + "img/mockup_rbm_cutoff.36a7e451.png";